module.exports = __webpack_public_path__ + "static/assets/60b311821633327b03f0221b788cf8ce.gif";